import React, { Component } from 'react';
import './loading.css';

class Loading extends Component {
 	constructor(props) {
		super(props);		
		this.timeout = 0;
		
		this.hideLoader = this.hideLoader.bind(this);
		this.showLoader = this.showLoader.bind(this);
		
		this.state = {
			"visible": true,
			"$html": null
		}
	}
	
	componentDidMount() {
		this.setState(
			{ "$html": document.documentElement }
		);
	}
  
	componentDidUpdate( prevProps, prevState ) {
		//console.log( prevProps, this.props.Show );
		
		if ( prevProps.Show !== this.props.Show ) {
			if ( this.props.Show ) {
				this.setState(
					{ "visible": true },
					this.showLoader
				);
			} else {
				this.hideLoader();
			}
		}
	}
  
	componentWillUnmout() {
		clearTimeout( this.timeout );
	}
	
	showLoader() {
		this.state.$html.classList.add( "loading-visible" );
		this.timeout = setTimeout(
			() => {
				this.state.$html.classList.add( "loading-in" );
			},
			1
		);
	}
	
	hideLoader() {
		window.scrollTo( 0, 0 );
		this.state.$html.classList.remove("loading-in");
		this.timeout = setTimeout(
			() => {
				this.state.$html.classList.remove( "loading-visible" );
				this.setState( { "visible": false } );
			},
			this.props.AnimationDuration
		);
	}
  
	render() {
		if ( this.state.visible ) {
			return ( <div className="loading"><div className="in"><h2><svg id="loading-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
    <g id="loading-logo-small-group" transform="translate(0.000000, 84.000000)">
        <rect id="loading-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
        <rect id="loading-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
    </g>
</svg></h2></div></div> );
		} else {
			return null;
		}
	}
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Elezioni/loading.js